import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";

import LoginPage from "./LoginPage";
import { API_ROOT, colors, checkStatus, parseJSON } from "../util/constants";
import NewInput from "./FormComponents/NewInput";
import NewButton from "./FormComponents/NewButton";

class ForgotPass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      processing: false,
      error: true,
      errorText: "",
      success: false
    };
  }
  handleEmail = e => {
    this.setState({
      email: e.target.value
    });
  };
  submitForgotPass = e => {
    e.preventDefault();
    if (this.state.email !== "") {
      this.setState({ processing: true, error: false });

      var myRequestUrl = API_ROOT + "forgotPass.php";
      var formData = new FormData();

      formData.append("email", this.state.email);
      var self = this;
      fetch(myRequestUrl, {
        method: "POST",
        body: formData,
        credentials: "same-origin"
      })
        .then(checkStatus)
        .then(parseJSON)
        .then(function(data) {
          if (data.status) {
            self.setState({ success: true, processing: false });
          } else {
            self.setState({
              error: true,
              errorText: data.msg,
              processing: false
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    } else {
      this.setState({ error: true, errorText: "All fields are mandatory." });
    }
  };
  closeForgotPass = () => {
    ReactDOM.render(<LoginPage />, document.getElementById("login-container"));
  };
  render() {
    return (
      <Container>
        <div className="close" onClick={this.closeForgotPass}>
          <span />
        </div>
        <p>Please enter your registered email address.</p>
        <form method="post" onSubmit={this.submitForgotPass}>
          <NewInput
            type="email"
            autoComplete="email"
            placeholder="Registered Email"
            autoFocus={true}
            required={true}
            onChange={this.handleEmail}
            margin="0 0 10px"
          />
          {this.state.error && <ErrorText>{this.state.errorText}</ErrorText>}
          {this.state.success && (
            <SuccessText>
              Reset password link has be sent to your registered email.
            </SuccessText>
          )}
          <NewButton block type="submit" disabled={this.state.processing}>
            {this.state.processing ? "Processing.." : "Reset"}
          </NewButton>
        </form>
      </Container>
    );
  }
}
const ErrorText = styled.p`
  font-size: 16px !important;
  font-weight: 500 !important;
  color: ${colors.error} !important;
  margin: 10px 0 !important;
  padding: 0 !important;
  text-align: center !important;
`;
const Container = styled.div`
  width: 90%;
  max-width: 400px;
  padding: 2rem 1rem;
  border-radius: 3px;
  background-color: #ffffff;

  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
`;

const SuccessText = styled.p`
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #33cc99 !important;
  margin: 10px 0 !important;
  padding: 0 !important;
  text-align: center !important;
`;
export default ForgotPass;



// WEBPACK FOOTER //
// ./src/components/ForgotPass.js